export const _LOAD_MODEL_COMPANY_ = 'Load:Company';
export const _LOAD_MODEL_MESSAGE_ = 'Load:Message';
export const _LOAD_MODEL_SETTING_ = 'Load:Setting';

export const COMPANY = {
  city: '',
  cnpj: '',
  site: '',
  state: '',
  email: '',
  number: '',
  address: '',
  zipcode: '',
  district: '',
  whatsapp1: '',
  whatsapp2: '',
  instagram: '',
};

export const MESSAGES = {
  footer: '',
  slogan: '',
  receipt: '',
  warranty: '',
  approbation: '',
  sendMessage: '',
  sendMessageWhats: '',
};

export const SETTINGS = {
  logo: null,
  motor: null,
  pelmet: null,
  reducer: null,
  warranty: null,
  timeAlert: null,
  pelmetRoller: null,
};
